// Module
var code = "<div class=\"push\"> </div>";
// Exports
module.exports = code;